import { Frequency as PackagesFrequency } from '@vendasta/marketplace-packages';
import { FrequencyEnum as CoreFrequency } from '@vendasta/shared';

export function convertCentsToDollars(centValue: number): number {
  if (!centValue) {
    return centValue;
  }

  if (!Number.isInteger(centValue)) {
    centValue = Number(centValue);
    centValue = Math.round(centValue);
  }
  return centValue / 100;
}

export function convertDollarsToCents(dollarValue: number): number {
  if (!dollarValue) {
    return dollarValue;
  }

  let centValue = dollarValue * 100;
  if (!Number.isInteger(centValue)) {
    centValue = Number(centValue);
    centValue = Math.round(centValue);
  }
  return centValue;
}

type PriceConversion = 'cents_to_dollars' | 'dollars_to_cents';

export function convertPrice(price: number, conversion: PriceConversion): number {
  if (!(price > 0)) {
    return price;
  }

  return conversion === 'cents_to_dollars' ? convertCentsToDollars(price) : convertDollarsToCents(price);
}

export function convertPackagesFrequencyToCoreFrequency(frequency: PackagesFrequency): CoreFrequency {
  switch (frequency) {
    case PackagesFrequency.ONCE:
      return CoreFrequency.ONE_TIME;
    case PackagesFrequency.YEARLY:
      return CoreFrequency.YEARLY;
    default:
      return CoreFrequency.MONTHLY;
  }
}
